import html from "./NewsFeed.html"
import "./NewsFeed.css"

var module = angular.module("ResearchKitApplicationModule");

module.component('mdhNewsFeed', {
	template: html,
	bindings: {
		"patientId": "<",
		"feed": "<",
		"drilldownDashboard": "<"
	},
	controller: 'mdhNewsFeedController',
	controllerAs: 'vm'
});

module.controller("mdhNewsFeedController", ["$scope", "$http", "ceUrl", "$timeout",
	function ($scope, $http, ceUrl, $timeout) {
		var vm = this;

		$scope.$on('ShowNewsFeedPatient', function (event, patientID) {
			$scope.$emit('NavigateToView', { type: 'Dashboard', dashboardKey: vm.drilldownDashboard, patientID: patientID });
		});

		$scope.$on('NewsFeedCaregiverDrilldown', function (event, caregiver) {
			$scope.drilldownData = JSON.parse(caregiver);
			$scope.drilldownType = 'Caregiver';
		});

		$scope.$on('NewsFeedShowReport', function (event, eventObject) {
			$scope.drilldownData = JSON.parse(eventObject)
			$scope.drilldownType = $scope.drilldownData.Type;
		});

		$scope.$on('NewsFeedEventDrilldown', function (event, eventObject) {
			$scope.drilldownData = JSON.parse(eventObject);
			$scope.drilldownType = 'Event';
		});
	}
]);